var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-link btn-l",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v("←")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("progress-bar", {
                  attrs: { options: _vm.options, value: 100 }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-4 card" }, [
              _c("h4", {
                staticClass: "text-primary",
                domProps: { innerHTML: _vm._s(_vm.data.consent.consentHeader) }
              }),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.data.consent.topText) }
              }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.clarificationText) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn btn-cnsnt btn-primary btn-lg btn-block",
                domProps: {
                  innerHTML: _vm._s(_vm.data.consent.approveBtnText)
                },
                on: {
                  click: function($event) {
                    return _vm.$router.push("/cnfrm")
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("small", {
                staticClass: "disclaimer",
                domProps: { innerHTML: _vm._s(_vm.data.consent.disclaimerText) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: { id: "terms", role: "dialog" }
            },
            [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h4", { staticClass: "modal-title text-center" }, [
                      _vm._v(_vm._s(_vm.data.consent.termsAndConditionsLabel))
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "data-dismiss": "modal" }
                      },
                      [_vm._v("×")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.consent.termsAndConditionsText
                        )
                      }
                    })
                  ])
                ])
              ])
            ]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16ca551a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ca551a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Consent.vue
// module id = null
// module chunks = 